import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Fragment, useContext, useEffect, useState } from "react";
import { Button, Col, Row, Table, Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { BasicContext } from "../../../../App";
import UserClass from "../../../../components/classes/UserClass";
import LoadedRecords from "../../../../components/LoadedRecords";
import Reservation from "../../../../components/Reservation";
import { postMethod } from "../../../../requests";
import { UDContext } from "./UserDetails";

const UserDetailsClasses = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(true);
    const { checkServerData, showView, NOR } = useContext(BasicContext);
    const [activeClasses, setActiveClasses] = useState(null);
    const [historyClasses, setHistoryClasses] = useState(null);
    const [reservations, setReservations] = useState(null);
    const [displayNOR, setDisplayNOR] = useState(NOR);
    const [reservView, setReservView] = useState(false);
    const { reloadData } = useContext(UDContext);

    const getUserClasses = async () => {
        const res = await postMethod("/get-user-classes", { userID: showView.params.userID });
        if (checkServerData(res)) {
            setActiveClasses(res.data.activeClasses);
            setHistoryClasses(res.data.historyClasses);
            setReservations(res.data.reservations);
            setReservView(res.data.setReservView);
        }
        setLoading(false);
    };

    useEffect(() => {
        getUserClasses();
        // eslint-disable-next-line
    }, []);

    return (
        <Container>
            <Row>
                {loading ? (
                    <Col className="text-center">
                        <FontAwesomeIcon icon={faSpinner} className="rotate-center" />
                    </Col>
                ) : (
                    <Fragment>
                        {activeClasses && (
                            <Fragment>
                                <Col xs={12} className="px-4">
                                    <p className="h6 mb-3">{t("classes.assignedClasses")}</p>
                                </Col>
                                <Col xs={12} className="px-0">
                                    {activeClasses.length === 0 ? (
                                        <p className="opacity-75 fs-6 text-center">{t("classes.noAssignedActiveClasses")}</p>
                                    ) : (
                                        <Table className="white-table mb-3" size="sm">
                                            <tbody>
                                                {activeClasses.map((e, i) => (
                                                    <Fragment key={i}>
                                                        <UserClass c={e} onlyDisplay showUA />
                                                    </Fragment>
                                                ))}
                                            </tbody>
                                        </Table>
                                    )}
                                </Col>
                            </Fragment>
                        )}
                        {reservations && (
                            <Fragment>
                                <Col xs={12} className="px-4">
                                    <p className="h6 my-3">{t("reservations.activeReservations")}</p>
                                </Col>
                                <Col xs={12} className="px-0">
                                    {reservations.length === 0 ? (
                                        <p className="opacity-75 fs-6 text-center">{t("reservations.noActiveReservations")}</p>
                                    ) : (
                                        <Table className="white-table mb-3" size="sm">
                                            <tbody>
                                                {reservations.map((e, i) => (
                                                    <Fragment key={i}>
                                                        <Reservation reserv={e} noAssignInfo reservView={reservView} reloadData={() => reloadData("classes")} />
                                                    </Fragment>
                                                ))}
                                            </tbody>
                                        </Table>
                                    )}
                                </Col>
                            </Fragment>
                        )}
                        {historyClasses && (
                            <Fragment>
                                <Col xs={12} className="px-4">
                                    <p className="my-3 h6">{t("classes.historyClassesList")}</p>
                                </Col>
                                <Col xs={12}>
                                    {historyClasses.length === 0 ? (
                                        <p className="opacity-75 fs-6 text-center">{t("classes.noHistoryClasses")}</p>
                                    ) : (
                                        <Row>
                                            <LoadedRecords displayNOR={displayNOR} list={historyClasses} />
                                            <Col xs={12} className="px-0">
                                                <Table size="sm" className="mb-3">
                                                    <tbody>
                                                        {historyClasses.map((e, i) => (
                                                            <Fragment key={i}>
                                                                <UserClass c={e} onlyDisplay showUA />
                                                            </Fragment>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                            </Col>
                                            <LoadedRecords displayNOR={displayNOR} list={historyClasses} />
                                            <Col xs={12} className="text-center">
                                                {displayNOR >= historyClasses.length ? (
                                                    <p className="opacity-4  mb-3">
                                                        <span className="px-3">{t("thatsAll")}</span>
                                                    </p>
                                                ) : (
                                                    <Button onClick={() => setDisplayNOR(NOR + displayNOR)} variant="outline-primary" className="mb-3">
                                                        {t("loadMore")}
                                                    </Button>
                                                )}
                                            </Col>
                                        </Row>
                                    )}
                                </Col>
                            </Fragment>
                        )}
                    </Fragment>
                )}
            </Row>
        </Container>
    );
};

export default UserDetailsClasses;
